module.exports = __webpack_public_path__ + "static/media/volume.cf188b92.svg";